import React, { useState } from 'react';
import { Card, Tabs, Form, Input, Button, Radio, Table, Tag, Space, Upload, message, Modal, Row, Col, Select } from 'antd';
import { NotificationOutlined, PlusOutlined, SearchOutlined, DeleteOutlined, EditOutlined, UploadOutlined, SendOutlined, MobileOutlined, MailOutlined, ApiOutlined, SoundOutlined } from '@ant-design/icons';

const { TabPane } = Tabs;

const PushManagement = () => {
  const [activeTab, setActiveTab] = useState('sms');
  const [loading, setLoading] = useState(false);
  const [smsForm] = Form.useForm();
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  
  // 模拟短信推送记录数据
  const smsRecords = [
    {
      id: 1,
      phoneNumber: '13800138000',
      content: '您有一条新的警告消息，请及时查看。',
      status: 'success',
      time: '2025-03-18 15:10:25',
    },
    {
      id: 2,
      phoneNumber: '13900139000',
      content: '系统检测到异常人流量，请注意安全。',
      status: 'success',
      time: '2025-03-18 14:30:12',
    },
    {
      id: 3,
      phoneNumber: '13700137000',
      content: '您的账号已成功登录系统。',
      status: 'failed',
      time: '2025-03-18 13:45:33',
    },
    {
      id: 4,
      phoneNumber: '13600136000',
      content: '系统维护通知：系统将于今晚22:00-23:00进行例行维护。',
      status: 'pending',
      time: '2025-03-18 12:20:45',
    },
  ];

  // 模拟办公推送记录数据
  const officeRecords = [
    {
      id: 1,
      title: '系统升级通知',
      content: '系统将于2025年3月20日进行版本升级，届时将暂停服务2小时。',
      recipients: '所有用户',
      status: 'sent',
      time: '2025-03-18 15:20:10',
    },
    {
      id: 2,
      title: '安全检查通知',
      content: '请各部门做好安全检查工作，及时排除安全隐患。',
      recipients: '安全部门',
      status: 'draft',
      time: '2025-03-18 14:15:30',
    },
  ];

  // 模拟接口推送记录数据
  const apiRecords = [
    {
      id: 1,
      apiName: '警告推送接口',
      requestUrl: 'https://api.example.com/warnings',
      lastPushTime: '2025-03-18 15:30:22',
      status: 'active',
    },
    {
      id: 2,
      apiName: '人流数据推送',
      requestUrl: 'https://api.example.com/people-flow',
      lastPushTime: '2025-03-18 15:25:18',
      status: 'active',
    },
    {
      id: 3,
      apiName: '系统状态推送',
      requestUrl: 'https://api.example.com/system-status',
      lastPushTime: '2025-03-18 14:10:05',
      status: 'inactive',
    },
  ];

  // 模拟语音推送记录数据
  const voiceRecords = [
    {
      id: 1,
      title: '紧急疏散通知',
      content: '请所有人员立即疏散到安全区域。',
      playTimes: 3,
      status: 'played',
      time: '2025-03-18 10:15:30',
    },
    {
      id: 2,
      title: '日常安全提醒',
      content: '请注意安全，保持通道畅通。',
      playTimes: 2,
      status: 'scheduled',
      time: '2025-03-18 16:00:00',
    },
  ];

  // 短信记录表格列定义
  const smsColumns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60,
    },
    {
      title: '手机号',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
    },
    {
      title: '内容',
      dataIndex: 'content',
      key: 'content',
      ellipsis: true,
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        let color = 'green';
        let text = '成功';
        if (status === 'failed') {
          color = 'red';
          text = '失败';
        } else if (status === 'pending') {
          color = 'gold';
          text = '处理中';
        }
        return <Tag color={color}>{text}</Tag>;
      },
    },
    {
      title: '时间',
      dataIndex: 'time',
      key: 'time',
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space size="small">
          <Button 
            type="link" 
            size="small"
            onClick={() => handleViewSms(record)}
          >
            查看
          </Button>
          <Button 
            type="link" 
            danger 
            size="small"
            onClick={() => handleDeleteSms(record)}
          >
            删除
          </Button>
        </Space>
      ),
    },
  ];

  // 办公推送记录表格列定义
  const officeColumns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60,
    },
    {
      title: '标题',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: '内容',
      dataIndex: 'content',
      key: 'content',
      ellipsis: true,
    },
    {
      title: '接收者',
      dataIndex: 'recipients',
      key: 'recipients',
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        let color = 'green';
        let text = '已发送';
        if (status === 'draft') {
          color = 'blue';
          text = '草稿';
        }
        return <Tag color={color}>{text}</Tag>;
      },
    },
    {
      title: '时间',
      dataIndex: 'time',
      key: 'time',
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space size="small">
          <Button 
            type="link" 
            size="small"
            onClick={() => handleViewOffice(record)}
          >
            查看
          </Button>
          <Button 
            type="link" 
            size="small"
            onClick={() => handleEditOffice(record)}
          >
            编辑
          </Button>
          <Button 
            type="link" 
            danger 
            size="small"
            onClick={() => handleDeleteOffice(record)}
          >
            删除
          </Button>
        </Space>
      ),
    },
  ];

  // 接口推送记录表格列定义
  const apiColumns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60,
    },
    {
      title: '接口名称',
      dataIndex: 'apiName',
      key: 'apiName',
    },
    {
      title: '请求地址',
      dataIndex: 'requestUrl',
      key: 'requestUrl',
      ellipsis: true,
    },
    {
      title: '最后推送时间',
      dataIndex: 'lastPushTime',
      key: 'lastPushTime',
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        let color = 'green';
        let text = '活跃';
        if (status === 'inactive') {
          color = 'red';
          text = '未启用';
        }
        return <Tag color={color}>{text}</Tag>;
      },
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space size="small">
          <Button 
            type="link" 
            size="small"
            onClick={() => handleEditApi(record)}
          >
            编辑
          </Button>
          <Button 
            type="link" 
            size="small"
            onClick={() => handleTestApi(record)}
          >
            测试
          </Button>
          <Button 
            type="link" 
            danger 
            size="small"
            onClick={() => handleDeleteApi(record)}
          >
            删除
          </Button>
        </Space>
      ),
    },
  ];

  // 语音推送记录表格列定义
  const voiceColumns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60,
    },
    {
      title: '标题',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: '内容',
      dataIndex: 'content',
      key: 'content',
      ellipsis: true,
    },
    {
      title: '播放次数',
      dataIndex: 'playTimes',
      key: 'playTimes',
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        let color = 'green';
        let text = '已播放';
        if (status === 'scheduled') {
          color = 'blue';
          text = '已安排';
        }
        return <Tag color={color}>{text}</Tag>;
      },
    },
    {
      title: '时间',
      dataIndex: 'time',
      key: 'time',
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space size="small">
          <Button 
            type="link" 
            size="small"
            onClick={() => handlePlayVoice(record)}
          >
            播放
          </Button>
          <Button 
            type="link" 
            size="small"
            onClick={() => handleEditVoice(record)}
          >
            编辑
          </Button>
          <Button 
            type="link" 
            danger 
            size="small"
            onClick={() => handleDeleteVoice(record)}
          >
            删除
          </Button>
        </Space>
      ),
    },
  ];

  // 处理查看短信
  const handleViewSms = (record) => {
    Modal.info({
      title: '短信详情',
      content: (
        <div>
          <p><strong>手机号：</strong> {record.phoneNumber}</p>
          <p><strong>内容：</strong> {record.content}</p>
          <p><strong>状态：</strong> {
            record.status === 'success' ? '成功' : 
            record.status === 'failed' ? '失败' : '处理中'
          }</p>
          <p><strong>时间：</strong> {record.time}</p>
        </div>
      ),
    });
  };

  // 处理删除短信
  const handleDeleteSms = (record) => {
    Modal.confirm({
      title: '确认删除',
      content: `确定要删除此短信记录吗？`,
      onOk() {
        message.success('删除成功');
      },
    });
  };

  // 处理查看办公推送
  const handleViewOffice = (record) => {
    Modal.info({
      title: '推送详情',
      content: (
        <div>
          <p><strong>标题：</strong> {record.title}</p>
          <p><strong>内容：</strong> {record.content}</p>
          <p><strong>接收者：</strong> {record.recipients}</p>
          <p><strong>状态：</strong> {record.status === 'sent' ? '已发送' : '草稿'}</p>
          <p><strong>时间：</strong> {record.time}</p>
        </div>
      ),
    });
  };

  // 处理编辑办公推送
  const handleEditOffice = (record) => {
    setSelectedRecord(record);
    setModalVisible(true);
  };

  // 处理删除办公推送
  const handleDeleteOffice = (record) => {
    Modal.confirm({
      title: '确认删除',
      content: `确定要删除推送记录吗？`,
      onOk() {
        message.success('删除成功');
      },
    });
  };

  // 处理编辑API接口
  const handleEditApi = (record) => {
    message.info(`编辑接口: ${record.apiName}`);
    // 实际项目中这里应该打开编辑模态框
  };

  // 处理测试API接口
  const handleTestApi = (record) => {
    message.loading('正在测试接口...');
    setTimeout(() => {
      message.success('接口测试成功');
    }, 1500);
  };

  // 处理删除API接口
  const handleDeleteApi = (record) => {
    Modal.confirm({
      title: '确认删除',
      content: `确定要删除接口 "${record.apiName}" 吗？`,
      onOk() {
        message.success('删除成功');
      },
    });
  };

  // 处理播放语音
  const handlePlayVoice = (record) => {
    message.info(`正在播放: ${record.title}`);
    // 实际项目中这里应该调用语音播放功能
  };

  // 处理编辑语音
  const handleEditVoice = (record) => {
    message.info(`编辑语音: ${record.title}`);
    // 实际项目中这里应该打开编辑模态框
  };

  // 处理删除语音
  const handleDeleteVoice = (record) => {
    Modal.confirm({
      title: '确认删除',
      content: `确定要删除语音 "${record.title}" 吗？`,
      onOk() {
        message.success('删除成功');
      },
    });
  };

  // 处理短信推送表单提交
  const handleSmsSubmit = (values) => {
    console.log('短信推送表单提交:', values);
    message.success('短信发送成功');
    smsForm.resetFields();
  };

  return (
    <div>
      <Card title={
        <span>
          <NotificationOutlined style={{ marginRight: 8 }} />
          推送管理
        </span>
      }>
        <Tabs activeKey={activeTab} onChange={setActiveTab}>
          <TabPane 
            tab={
              <span>
                <MobileOutlined />
                短信推送
              </span>
            } 
            key="sms"
          >
            <Row gutter={16}>
              <Col span={12}>
                <Card title="发送短信" bordered={false}>
                  <Form 
                    form={smsForm}
                    layout="vertical"
                    onFinish={handleSmsSubmit}
                  >
                    <Form.Item
                      name="phoneNumber"
                      label="手机号码"
                      rules={[{ required: true, message: '请输入手机号码' }]}
                    >
                      <Input placeholder="请输入手机号码" />
                    </Form.Item>
                    <Form.Item
                      name="content"
                      label="短信内容"
                      rules={[{ required: true, message: '请输入短信内容' }]}
                    >
                      <Input.TextArea rows={4} placeholder="请输入短信内容" />
                    </Form.Item>
                    <Form.Item>
                      <Button type="primary" htmlType="submit" icon={<SendOutlined />}>
                        发送
                      </Button>
                    </Form.Item>
                  </Form>
                </Card>
              </Col>
              <Col span={12}>
                <Card title="短信推送记录" bordered={false}>
                  <div className="search-bar" style={{ marginBottom: 16 }}>
                    <Input.Search placeholder="搜索手机号或内容" style={{ width: 300 }} />
                  </div>
                  <Table 
                    columns={smsColumns} 
                    dataSource={smsRecords} 
                    rowKey="id" 
                    loading={loading}
                    pagination={{ pageSize: 5 }}
                    size="small"
                  />
                </Card>
              </Col>
            </Row>
          </TabPane>
          
          <TabPane 
            tab={
              <span>
                <MailOutlined />
                办公推送
              </span>
            } 
            key="office"
          >
            <div className="button-group">
              <Button type="primary" icon={<PlusOutlined />} onClick={() => setModalVisible(true)}>
                新建推送
              </Button>
            </div>
            <Table 
              columns={officeColumns} 
              dataSource={officeRecords} 
              rowKey="id" 
              loading={loading}
              pagination={{ pageSize: 10 }}
            />
          </TabPane>
          
          <TabPane 
            tab={
              <span>
                <ApiOutlined />
                接口推送
              </span>
            } 
            key="api"
          >
            <div className="button-group">
              <Button type="primary" icon={<PlusOutlined />}>
                添加接口
              </Button>
            </div>
            <Table 
              columns={apiColumns} 
              dataSource={apiRecords} 
              rowKey="id" 
              loading={loading}
              pagination={{ pageSize: 10 }}
            />
          </TabPane>
          
          <TabPane 
            tab={
              <span>
                <SoundOutlined />
                语音推送
              </span>
            } 
            key="voice"
          >
            <div className="button-group">
              <Button type="primary" icon={<PlusOutlined />}>
                添加语音
              </Button>
            </div>
            <Table 
              columns={voiceColumns} 
              dataSource={voiceRecords} 
              rowKey="id" 
              loading={loading}
              pagination={{ pageSize: 10 }}
            />
          </TabPane>
        </Tabs>
      </Card>

      {/* 办公推送模态框 */}
      <Modal
        title={selectedRecord ? '编辑推送' : '新建推送'}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
      >
        <Form layout="vertical">
          <Form.Item
            name="title"
            label="标题"
            initialValue={selectedRecord?.title}
            rules={[{ required: true, message: '请输入标题' }]}
          >
            <Input placeholder="请输入标题" />
          </Form.Item>
          <Form.Item
            name="content"
            label="内容"
            initialValue={selectedRecord?.content}
            rules={[{ required: true, message: '请输入内容' }]}
          >
            <Input.TextArea rows={4} placeholder="请输入内容" />
          </Form.Item>
          <Form.Item
            name="recipients"
            label="接收者"
            initialValue={selectedRecord?.recipients}
            rules={[{ required: true, message: '请选择接收者' }]}
          >
            <Select placeholder="请选择接收者">
              <Select.Option value="所有用户">所有用户</Select.Option>
              <Select.Option value="安全部门">安全部门</Select.Option>
              <Select.Option value="管理员">管理员</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ marginRight: 8 }}>
              {selectedRecord ? '更新' : '发送'}
            </Button>
            <Button onClick={() => setModalVisible(false)}>
              取消
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default PushManagement;
